import { Sheet } from 'react-modal-sheet';
import { ReactComponent as SIBErrorIcon } from '../../../../Assets/sib/error.svg';
import { pushEventToParent } from '../../../../Utils/eventUtils';
import styles from './index.module.css';

interface SIBErrorScreenProps {
  title?: string;
  message: string;
  buttonText?: string;
  onButtonClick?: () => void;
  fullScreen?: boolean;
}

const SIBErrorScreen = ({
  title,
  message,
  buttonText = 'Okay',
  onButtonClick,
  fullScreen = false,
}: SIBErrorScreenProps) => {
  const handleClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      pushEventToParent({ eventCode: 'GO_BACK' });
    }
  };

  if (fullScreen) {
    return (
      <div className={styles.sibFullScreenContainer}>
        <div className={styles.sibContentWrapper}>
          <SIBErrorIcon className={styles.sibErrorIcon} />

          <h1 className={styles.sibErrorTitle}>{title}</h1>

          <p className={styles.sibErrorDescription}>{message}</p>

          <button className={styles.sibOkButton} onClick={handleClick}>
            {buttonText}
          </button>
        </div>
      </div>
    );
  }

  return (
    <Sheet
      style={{ zIndex: 10000 }}
      isOpen={true}
      onClose={() => {}}
      detent='content-height'
      disableScrollLocking={true}
      disableDrag={true}
    >
      <Sheet.Container className={styles.sheet_container}>
        <Sheet.Content>
          <div className={styles.sibContentWrapper}>
            <SIBErrorIcon className={styles.sibErrorIcon} />

            <h1 className={styles.sibErrorTitle}>{title}</h1>

            <p className={styles.sibErrorDescription}>{message}</p>

            <button className={styles.sibOkButton} onClick={handleClick}>
              {buttonText}
            </button>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop style={{ background: 'rgba(0, 0, 0, 0.4)' }} />
    </Sheet>
  );
};

export default SIBErrorScreen;
